import { render, staticRenderFns } from "./ClaimReserveHelpList.vue?vue&type=template&id=097df86a&"
import script from "./ClaimReserveHelpList.vue?vue&type=script&lang=js&"
export * from "./ClaimReserveHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports